import { render, staticRenderFns } from "./EduCourseCharpterStudentrecord.vue?vue&type=template&id=bfdfc96e&scoped=true&"
import script from "./EduCourseCharpterStudentrecord.vue?vue&type=script&lang=js&"
export * from "./EduCourseCharpterStudentrecord.vue?vue&type=script&lang=js&"
import style0 from "./EduCourseCharpterStudentrecord.vue?vue&type=style&index=0&id=bfdfc96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdfc96e",
  null
  
)

export default component.exports